/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Confirmationemailsendat3Inputs */

const de__field_confirmationemailsendat3 = /** @type {(inputs: _Field_Confirmationemailsendat3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestätigungsemail gesendet am`)
};

/**

* @param {_Field_Confirmationemailsendat3Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_confirmationemailsendat3 = /** @type {((inputs?: _Field_Confirmationemailsendat3Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Confirmationemailsendat3Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_confirmationemailsendat3(inputs)
});
export { _field_confirmationemailsendat3 as "_field_confirmationEmailSendAt" }